import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getMostPopular, getRecentlyViewed } from './thunk'

const initialState = {
  dataMostPopular: [],
  dataRecentlyViewed: [],
  loading: {
    mostPopular: true,
    recentlyViewed: true,
  },
}

const slice = createSlice({
  name: 'dashboard/recentlyAndPopular',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getMostPopular
    builder.addCase(getMostPopular.pending, (state, action) => {
      state.loading.mostPopular = true
    })
    builder.addCase(getMostPopular.fulfilled, (state, action) => {
      state.dataMostPopular = action.payload
      state.loading.mostPopular = false
    })
    builder.addCase(getMostPopular.rejected, (state, action) => {
      state.loading.mostPopular = action.payload.loading
    })
    //getRecentlyViewed
    builder.addCase(getRecentlyViewed.pending, (state, action) => {
      state.loading.recentlyViewed = true
    })
    builder.addCase(getRecentlyViewed.fulfilled, (state, action) => {
      state.dataRecentlyViewed = action.payload
      state.loading.recentlyViewed = false
    })
    builder.addCase(getRecentlyViewed.rejected, (state, action) => {
      state.loading.recentlyViewed = action.payload.loading
    })
  },
})

//loading
export const loadingRecentlyAndPopular = (type) => (state) =>
  state[slice.name].loading[type]

export const selectDataMostPopular = (state) =>
  state[slice.name].dataMostPopular
export const selectDataRecentlyViewed = (state) =>
  state[slice.name].dataRecentlyViewed

register(slice.name, slice.reducer)
